import { isMobile, removePreload } from '../helpers'
import { passiveEvent, captureEvent } from './optionsSupport'
import { keys, isKey } from './keyCodes'

import { updateViewportValues } from '../../modules/UI/viewport'

class Events {
  constructor(app) {
    this.app = app

    this.resizeTimer = null

    // Needed for removeEventListener (https://gist.github.com/Restuta/e400a555ba24daa396cc)
    this.onPreloadEnd = this.onPreloadEnd.bind(this)

    this.init()
  }

  onKeyDown(e) {
    if (isKey(e, 'escape')) {
      if (this.app.serviceMenu.close()) { return }

      this.app.menu.close()
    }
  }

  onResize() {
    clearTimeout(this.resizeTimer)
    document.body.classList.add('resizing')

    let wasMobile = this.app.state.isMobile

    this.resizeTimer = setTimeout(() => {
      updateViewportValues(this.app.root)

      document.body.classList.remove('resizing')

      this.app.state.isMobile = isMobile()

      const isMobileHasChanged = this.app.state.isMobile !== wasMobile

      // Menu and Service menu
      this.app.menu.onResize(isMobileHasChanged)
      this.app.serviceMenu.onResize(this.app.state.isMobile, isMobileHasChanged)

      // Sliders
      if ('sliders' in this.app) {
        this.app.sliders.resize()
      }

      // Cases Masonry
      if ('casesMasonry' in this.app) {
        this.app.casesMasonry.resize()
      }
    }, 100)
  }

  onTap(e) {
    if (!this.app.state.dragging) {
      this.app.menu.onTap(e)
      this.app.serviceMenu.onTap(e)

      if ('workshopFormFetch' in this.app) {
        this.app.workshopFormFetch.onTap(e)
      }
    }
  }

  onTouchMove() {
    this.app.state.dragging = true
    document.body.classList.add('dragging')
  }

  onTouchEnd() {
    this.app.state.dragging = false
    document.body.classList.remove('dragging')
  }

  onFocusIn(e) {
    if ('stackedFormLabels' in this.app) {
      this.app.stackedFormLabels.onFocusIn(e)
    }
  }

  onChange(e) {
    if ('stackedFormLabels' in this.app) {
      this.app.stackedFormLabels.onChange(e)
    }
  }

  onFocusOut(e) {
    if ('stackedFormLabels' in this.app) {
      this.app.stackedFormLabels.onFocusOut(e)
    }
  }

  onSubmit(e) {
    if ('contactFormFetch' in this.app) {
      this.app.contactFormFetch.onSubmit(e)
    }

    if ('workshopFormFetch' in this.app) {
      this.app.workshopFormFetch.onSubmit(e)
    }
  }

  onReset(e) {
    if ('stackedFormLabels' in this.app) {
      this.app.stackedFormLabels.reset()
    }
  }

  onLoad(e) {
    if ('picUnveiler' in this.app) {
      this.app.picUnveiler.onLoad(e)
    }
  }

  onPreloadEnd({ target, propertyName }) {

    // Preloader fully arrived: company logo `*` fires transitionend.
    if (
      target.matches('.logo__char--star')
      && propertyName === 'transform'
      && this.app.root.classList.contains('transitioning')
    ) {
      return removePreload(this.app.root)
    }

    // Preloader fully gone: transition container fires transitionend.
    if (
      !this.app.root.classList.contains('transitioning')
      && target.classList.contains('transition')
    ) {
      this.app.root.classList.remove('preload')
      document.removeEventListener('transitionend', this.onPreloadEnd, passiveEvent)
    }
  }

  init() {
    updateViewportValues(this.app.root)

    // Loading
    document.addEventListener('load', this.onLoad.bind(this), captureEvent)

    // Resize
    window.addEventListener('resize', this.onResize.bind(this))

    // Pointers
    document.addEventListener(
      'touchmove',
      this.onTouchMove.bind(this),
      passiveEvent
    )

    document.addEventListener('touchstart', () => {}) // enable :hover in iOS
    document.addEventListener('touchend', this.onTouchEnd.bind(this))
    document.addEventListener('touchend', this.onTap.bind(this), captureEvent)
    document.addEventListener('click', this.onTap.bind(this), captureEvent)

    // Focus
    document.addEventListener('focusin', this.onFocusIn.bind(this))
    document.addEventListener('change', this.onChange.bind(this))
    document.addEventListener('focusout', this.onFocusOut.bind(this))

    // Forms
    document.addEventListener('submit', this.onSubmit.bind(this))
    document.addEventListener('reset', this.onReset.bind(this))

    // Keyboard
    document.addEventListener('keydown', this.onKeyDown.bind(this))

    // Preloader
    if (!this.app.root.classList.contains('still-waiting-for-js')) {
      return document.addEventListener('transitionend', this.onPreloadEnd, passiveEvent)
    }
    removePreload(this.app.root)
  }
}

export default function(app) {
  return new Events(app)
}



// WEBPACK FOOTER //
// ./resources/js/app/events/index.js